export interface VariantGroupMemberLike {
  id: string;
  selected: boolean;
}

export interface VariantGroupSelectState {
  total: number;
  /** Members not yet in the sync selection, the ones "Select all" would add. */
  unselectedIds: string[];
  count: number;
  allSelected: boolean;
}

/**
 * What the "Select all N variants" action shows. `selectedIds`, when given (the
 * browser's live sync selection), overrides the `selected` flag the server sent,
 * so the count follows the selection (added or removed) without a refetch.
 */
export function variantGroupSelectState(
  members: readonly VariantGroupMemberLike[],
  selectedIds?: ReadonlySet<string>,
): VariantGroupSelectState {
  const unselectedIds = members
    .filter((member) => !(selectedIds ? selectedIds.has(member.id) : member.selected))
    .map((member) => member.id);
  return {
    total: members.length,
    unselectedIds,
    count: unselectedIds.length,
    allSelected: members.length > 0 && unselectedIds.length === 0,
  };
}
